import React from 'react';
import { useMatch } from '../context/MatchContext';

function ToggleGroup({ label, options, value, onChange }) {
  return (
    <div className="biomech-group">
      <span className="panel-label">{label}</span>
      <div className="biomech-options">
        {options.map(opt => (
          <button
            key={opt.value}
            className={`toggle-btn${value === opt.value ? ' selected' : ''}`}
            onClick={() => onChange(value === opt.value ? null : opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

function BiomechPanel() {
  const { state, setActionField } = useMatch();
  const { currentAction } = state;

  return (
    <div className="panel">
      <div className="panel-header">Biomeccanica</div>
      <div className="panel-body">

        <ToggleGroup
          label="Gamba (lato)"
          value={currentAction.legSide}
          onChange={v => setActionField('legSide', v)}
          options={[
            { value: 'destra',    label: 'Destra' },
            { value: 'sinistra',  label: 'Sinistra' },
          ]}
        />

        <ToggleGroup
          label="Gamba (posizione)"
          value={currentAction.legPosition}
          onChange={v => setActionField('legPosition', v)}
          options={[
            { value: 'anteriore',  label: 'Ant.' },
            { value: 'posteriore', label: 'Post.' },
          ]}
        />

        <ToggleGroup
          label="Guardia"
          value={currentAction.guard}
          onChange={v => setActionField('guard', v)}
          options={[
            { value: 'aperta',  label: 'Ga' },
            { value: 'chiusa',  label: 'Gc' },
          ]}
        />

        <ToggleGroup
          label="Distanza"
          value={currentAction.distance}
          onChange={v => setActionField('distance', v)}
          options={[
            { value: 'corta',  label: 'Corta' },
            { value: 'media',  label: 'Media' },
          ]}
        />
        <div style={{ marginTop: -6 }}>
          <button
            className={`toggle-btn${currentAction.distance === 'lunga' ? ' selected' : ''}`}
            style={{ width: '100%' }}
            onClick={() => setActionField('distance', currentAction.distance === 'lunga' ? null : 'lunga')}
          >
            Lunga
          </button>
        </div>

      </div>
    </div>
  );
}

export default BiomechPanel;
